import { Typography } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next';
import styles from '../styles';

interface IHeaderDialogProps{
    titleKey: string,
    subtitleKey?: string
}

export default function HeaderDialog({subtitleKey,titleKey}:IHeaderDialogProps) {
    const {t} = useTranslation();
    const classes = styles();

    const title = t(titleKey);
    const subtitle = subtitleKey? t(subtitleKey):undefined;

    return (
        <div>
            <Typography className={classes.headerTitle} variant="caption">
                {title}
            </Typography>
            {
                subtitle && 
                <Typography className={classes.headerSubtitle} variant="h6"> 
                    {subtitle}
                </Typography>
            }
        </div>
    )
}